export function expandArray(arr: number[], n: number) {
  return arr.reduce((acc: number[], num) => {
    for (let i = 0; i < n; i++) {
      acc.push(num + i);
    }
    return acc;
  }, []);
}
